import { createFileRoute } from '@tanstack/react-router'

import { SnoozeSettingsPage } from '~/boundedContext/settings/pages/snooze-settings'

export const Route = createFileRoute('/_main-layout/settings/snooze')({
  component: SnoozeSettingsPage,
})
